import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { modelRedirectFn } from './utils';
import { gaEvents } from '../../utils/events';
import PalateDiscoveryTest from '../../containers/loggedIn/Feed/cards/PalateDiscoveryTest';

const Banner = (props) => {
  const { data, history } = props;
  const imageMeta = get(data, 'images_meta', {});
  const modelName = get(data, 'model_name');
  const isPalateDiscoveryCard = modelName === 'palate-discovery';

  const handleClick = (obj) => {
    gaEvents.landingpage.imageCard(modelName);
    const redirectUrl = modelRedirectFn(modelName, get(obj, 'model_id'));
    history.push(redirectUrl);
  };

  if (isPalateDiscoveryCard) { // API's returning banner type for palateCard 
    return (
      <PalateDiscoveryTest assignmentInfoFromFeed={data} />
    )
  }

  return (
    <div
      className="cursor-pointer feed-bannerimage"
      onClick={() => {
        handleClick(data);
      }}
    >
      <img src={get(imageMeta, 'original_photo', '')} alt="banner" />
    </div>
  );
};

Banner.propTypes = {
  data: PropTypes.object,
  history: PropTypes.object,
};
export default Banner;
